<template>
	<div class="avatar-outer-wrapper" :class="{ active: !!preset }">
		<div ref="wrapper" class="avatar-inner-wrapper">
			<img v-if="preset" :src="preset.largeImageBase64" />
			<img v-else src="@/assets/images/avatar_placeholder.png" alt="" />
		</div>
	</div>
</template>
<script>
import * as PIXI from 'pixi.js-legacy';

export default {
	props: {
		editable: {
			type: Boolean,
			default: false
		},
		preset: {
			type: Object,
			default: null
		},
		hairColor: {
			type: Number,
			default: null
		},
		skinColor: {
			type: Number,
			default: null
		},
		eyesColor: {
			type: Number,
			default: null
		},
		faceShape: {
			type: Number,
			default: 1
		},
		resources: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},

	data() {
		return {
			maxWidth: 432,
			pixiApp: null,
			pixiContainer: null,
			initialFaceWidth: null,
			initialHairWidth: null,
			initialHairCurlWidth: null,
			initialEyesWidth: null,
			face: null,
			hair: null,
			eyes: null,
			hairCurl: null
		};
	},

	computed: {
		// predefinedAvatar() {
		// 	if (!this.editable && this.preset) {
		// 		return require('@/' + this.preset.avatar);
		// 	}

		// 	return null;
		// },

		hexEyeColor() {
			return (this.eyesColor + 0x00000).toString(16).substr(-6);
		}
	},

	watch: {
		editable() {
			this.pixiApp.stage.removeChildren();
			this.face = null;
			this.hair = null;
			this.eyes = null;
			this.hairCurl = null;
		},
		// preset(obj) {
		// 	if (obj) {
		// 		if (this.editable) {
		// 			this.setFace();
		// 			this.setHairTint(this.hairColor);
		// 			this.setSkinTint(this.skinColor);
		// 			this.setFaceShape(this.faceShape);
		// 		} else {
		// 			const faceTexture = this.resources[this.preset.id].texture;
		// 			if (this.face) {
		// 				this.face.texture = this.resources[this.preset.id].texture;
		// 			} else {
		// 				this.face = new PIXI.Sprite(this.resources[this.preset.id].texture);
		// 				this.pixiApp.stage.addChild(this.face);
		// 			}
		// 			this.face.anchor.set(0.5);
		// 			this.initialFaceWidth = faceTexture.width;
		// 		}

		// 		this.resize();
		// 	}
		// },
		hairColor(value) {
			if (this.preset) {
				this.setHairTint(value);
			}
		},
		skinColor(value) {
			if (this.preset) {
				this.setSkinTint(value);
			}
		},
		eyesColor(value) {
			if (this.preset) {
				this.setEyesColor(value);
			}
		},
		faceShape(value) {
			if (this.preset) {
				this.setFaceShape(value);
			}
		}
	},

	mounted() {
		// 	const options = {
		// 		view: this.$refs['avatar-canvas'],
		// 		transparent: true,
		// 		autoResize: true,
		// 		resizeTo: this.$refs['wrapper'],
		// 		preserveDrawingBuffer: true,
		// 		resolution: window.devicePixelRatio || 1
		// 	};
		// 	PIXI.utils.skipHello();
		// 	this.pixiApp = new PIXI.Application(options);
		// 	window.onresize = function() {
		// 		this.resize();
		// 	}.bind(this);
	},

	beforeDestroy() {
		// window.onresize = null;
		// this.pixiApp.destroy();
		// PIXI.utils.clearTextureCache();
		// PIXI.utils.destroyTextureCache();
	},

	methods: {
		resize() {
			if (this.preset) {
				const scale = this.$refs['wrapper'].clientWidth / this.maxWidth;

				if (this.face) {
					this.face.scale.x = scale;
					this.face.scale.y = scale;
					this.face.x = this.pixiApp.screen.width / 2;
					this.face.y = this.pixiApp.screen.height / 2;
					this.face.width = this.initialFaceWidth * scale * this.faceShape;
				}

				if (this.hair) {
					this.hair.scale.x = scale;
					this.hair.scale.y = scale;
					this.hair.x = this.pixiApp.screen.width / 2;
					this.hair.y = this.pixiApp.screen.height / 2;
					this.hair.width = this.initialHairWidth * scale * this.faceShape;
				}

				if (this.hairCurl) {
					this.hairCurl.scale.x = scale;
					this.hairCurl.scale.y = scale;
					this.hairCurl.x = this.pixiApp.screen.width / 2;
					this.hairCurl.y = this.pixiApp.screen.height / 2;
					this.hairCurl.width =
						this.initialHairCurlWidth * scale * this.faceShape;
				}

				if (this.eyes) {
					this.eyes.scale.x = scale;
					this.eyes.scale.y = scale;
					this.eyes.x = this.pixiApp.screen.width / 2;
					this.eyes.y = this.pixiApp.screen.height / 2;
				}
			}
		},

		setFace() {
			const faceTexture = this.resources[
				`${this.preset.gender}_${this.preset.faceType}_face`
			].texture;

			if (this.face) {
				this.face.texture = faceTexture;
			} else {
				this.face = new PIXI.Sprite(faceTexture);
				this.pixiApp.stage.addChild(this.face);
			}
			this.face.anchor.set(0.5);
			this.initialFaceWidth = faceTexture.width;

			let gender = this.preset.gender;
			if (gender == 'a') {
				gender = 'f';
			}
			const eyesTexture = this.resources[`${gender}_${this.hexEyeColor}_eyes`]
				.texture;
			if (this.eyes) {
				this.eyes.texture = eyesTexture;
			} else {
				this.eyes = new PIXI.Sprite(eyesTexture);
				this.pixiApp.stage.addChild(this.eyes);
			}
			this.eyes.anchor.set(0.5);
			this.initialEyesWidth = eyesTexture.width;

			const hairTexture =
				this.preset.gender == 'm'
					? this.resources.m_hair.texture
					: this.resources[`${this.preset.gender}_${this.preset.faceType}_hair`]
							.texture;
			if (this.hair) {
				this.hair.texture = hairTexture;
			} else {
				this.hair = new PIXI.Sprite(hairTexture);
				this.pixiApp.stage.addChild(this.hair);
			}
			this.hair.anchor.set(0.5);
			this.initialHairWidth = hairTexture.width;

			if (this.preset.gender == 'f') {
				const hairCurlTexture = this.resources.f_hair_curl.texture;

				if (this.hairCurl) {
					this.hairCurl.texture = hairCurlTexture;
				} else {
					this.hairCurl = new PIXI.Sprite(hairCurlTexture);
					this.pixiApp.stage.addChild(this.hairCurl);
				}

				this.hairCurl.anchor.set(0.5);
				this.initialHairCurlWidth = hairCurlTexture.width;
			} else if (this.hairCurl) {
				this.hairCurl.texture = null;
			}
		},

		setSkinTint(color) {
			this.face.tint = color;
		},

		setHairTint(color) {
			this.hair.tint = color;
			if (this.hairCurl) {
				this.hairCurl.tint = color;
			}
		},

		setEyesColor() {
			let gender = this.preset.gender;
			if (gender == 'a') {
				gender = 'f';
			}
			this.eyes.texture = this.resources[
				`${gender}_${this.hexEyeColor}_eyes`
			].texture;
		},

		setFaceShape(coeff) {
			const scale = this.$refs['wrapper'].clientWidth / this.maxWidth;

			this.face.width = this.initialFaceWidth * scale * coeff;
			this.hair.width = this.initialHairWidth * scale * coeff;
			if (this.hairCurl) {
				this.hairCurl.width = this.initialHairWidth * scale * coeff;
			}
		}
	}
};
</script>
<style lang="scss">
.avatar-outer-wrapper {
	height: 0;
	width: 100%;
	padding-bottom: 100%;
	border-radius: 100%;
	position: relative;
	background-color: #dfe9f4;

	&.active {
		background: $avatar-wrapper-color;

		.avatar-inner-wrapper {
			background-color: #ffffff;
		}
	}

	.avatar-inner-wrapper {
		position: absolute;
		height: 0;
		width: 90%;
		padding-bottom: 90%;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		border-radius: 90%;

		img {
			margin: auto;
			position: absolute;
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			height: 60%;
		}
	}
}
</style>
